import { Type } from '../Type';
export class AnnotationList extends Array {
    type = Type.List;
    logicalType;
    tags;
    constructor(values = [], logicalType, tags) {
        super(...values);
        this.logicalType = logicalType;
        this.tags = tags;
    }
    static get [Symbol.species]() {
        return Array;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub3RhdGlvbkxpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL2xpc3QvQW5ub3RhdGlvbkxpc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUc5QixNQUFNLE9BQU8sY0FBZSxTQUFRLEtBQXFCO0lBQzlDLElBQUksR0FBUyxJQUFJLENBQUMsSUFBSSxDQUFBO0lBQ3RCLFdBQVcsQ0FBYztJQUN6QixJQUFJLENBQVc7SUFFeEIsWUFDRSxTQUEyQixFQUFFLEVBQzdCLFdBQXlCLEVBQ3pCLElBQWU7UUFFZixLQUFLLENBQUMsR0FBRyxNQUFNLENBQUMsQ0FBQTtRQUNoQixJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQTtRQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtJQUNsQixDQUFDO0lBRUQsTUFBTSxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQztRQUN6QixPQUFPLEtBQUssQ0FBQTtJQUNkLENBQUM7Q0FDRiJ9